import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Admin.css';
import logoimg from '../Components/Images/logonew (1).png';

const Admin_Navbar = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const logout = () => {
    localStorage.removeItem('token-info');
    localStorage.removeItem('userId');
    navigate('/admin');
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleNavClick = () => {
    if (window.innerWidth <= 1024) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setIsSidebarOpen(false); // Hide sidebar on tablets & mobile
      } else {
        setIsSidebarOpen(true); // Show sidebar on desktops
      }
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="main-content">
      {/* Toggle Button */}
      <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
        ☰
      </button>

      {/* Sidebar */}
      <div className={`admin_sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="logo-container">
          <img src={logoimg} alt="Logo" className="admin_sidebar-logo" />
        </div>

        <ul className="admin_sidebar-nav">
          <li><NavLink to="/admin/dashboard" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>Home</NavLink></li>
          <li><NavLink to="/admin/cardslider" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>Card Slider</NavLink></li>
          <li><NavLink to="/admin/collegepage" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>College Page</NavLink></li>
          <li><NavLink to="/admin/navcoursepagelist" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>Nav Course Page</NavLink></li>
          <li><NavLink to="/admin/stream" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>Stream</NavLink></li>
          <li><NavLink to="/admin/program" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>Program</NavLink></li>
          <li><NavLink to="/admin/StudyAbroad" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>Study Abroad</NavLink></li>
          <li><NavLink to="/admin/leads" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>Leads</NavLink></li>
          <li><NavLink to="/admin/review" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>Review</NavLink></li>
          <li><NavLink to="/admin/subscribe" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={handleNavClick}>Subscribers</NavLink></li>
        </ul>

        <div className="d-flex">
          <button className="m-auto text-center mybtn w-75" onClick={logout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Admin_Navbar;
